import React, { useContext, useState } from 'react';

import { AssetContext } from '@pages/Asset/Asset.query';
import { NavigationContext } from '@layout/navigation/navigation';
import { getPermissionData, setAttr } from '@utils';
import { getProductValue } from '@utils/getProductValue';
import { ITooltip, Text as TextComponent } from '@components/index';
import { checkDevice } from '@store/redux/features/mobile/mobileSelectors';
import { useSelector } from 'react-redux';
import { Icon } from '@blueprintjs/core';
import { Container, RowButton } from './NoContacts.styles';

const NoContacts = () => {
  const { openAddContact, equipmentQuery } = useContext(AssetContext);
  const { role } = useContext(NavigationContext);

  const addPermission = getPermissionData({
    owner: true,
    action: 'add',
    role,
    type: 'Contact',
  });

  const equipment = equipmentQuery?.data;
  const { manufacturerId, productId } = getProductValue(equipment);
  const hasProduct = manufacturerId && productId;
  const isEnabled = addPermission.allowed && hasProduct;

  const [tooltipId] = useState(() => {
    return `add-contacts-disabled-tooltip${Date.now()}`;
  });
  const { isDesktop } = useSelector(checkDevice());

  return (
    <Container>
      {isDesktop && (
        <RowButton
          className="new-icon"
          data-disabled={setAttr(!isEnabled)}
          onClick={() => {
            if (isEnabled) {
              openAddContact.set(true);
            }
          }}
          data-tip={addPermission.message}
          data-for={tooltipId}
        >
          <Icon icon="new-person" color="#1371fe" />
          <TextComponent text="b200" textColor="b401">
            Add your contacts
          </TextComponent>
        </RowButton>
      )}
      <TextComponent text="b200" textColor="n800" ta="center">
        You don&apos;t have any contacts yet!
      </TextComponent>
      <TextComponent maw={231} text="p200" textColor="n800">
        Contacts can be related to a manufacturer or shown in all your assets.
      </TextComponent>

      {/* <AddContact
        open={openAddContact}
        onClose={() => {
          setOpenAddContact(false);
        }}
      /> */}
      <ITooltip id={tooltipId} />
    </Container>
  );
};

export { NoContacts };
